import { useState } from "react";
import Sidebar from "../components/Sidebar";
import Nav from "../components/Nav";
import ChangePassword from "./ChangePassword";
// import UserRoles from "./UserRoles";  // Commented out for now
import "../styles/Settings.css";

function Settings() {
  // const [selectedTab, setSelectedTab] = useState("User Roles");
  const [selectedTab, setSelectedTab] = useState("Change Password"); // Default to Change Password since User Roles is disabled
  
  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <Sidebar />
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Nav />
        <div className="project-detail-container">
          {/* Tab Navigation */}
          <div className="tab-nav-container" style={{ marginBottom: 8 }}>
            {[
              // "User Roles",  // Commented out for now
              "Change Password"
            ].map((tab) => (
              <button
                key={tab}
                onClick={() => setSelectedTab(tab)}
                className={`tab-btn ${selectedTab === tab ? "active" : ""}`}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Content Card (tabs appear attached to this card) */}
          <div className="content-card">
            <div className="content-section">
              {/* {selectedTab === "User Roles" && <UserRoles />} */}

              {selectedTab === "Change Password" && (
                <div
                  style={{
                    display: "flex",
                    gap: "32px",
                    alignItems: "center",
                  }}
                >
                  {/* Change Password Form */}
                  <div style={{ flex: 1 }}>
                    <ChangePassword />
                  </div>
                  {/* Password Tips */}
                  <div style={{ minWidth: 280 }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: 12,
                      }}
                    >
                      <img
                        src="/assets/images/password.png"
                        alt="Password"
                        style={{ width: 64, height: 64, marginRight: 12 }}
                      />
                      <span style={{ fontSize: 18, fontWeight: 600, color: '#333' }}>
                        Password Tips
                      </span>
                    </div>
                    <ul style={{ fontSize: 14, color: "#555", paddingLeft: 20, lineHeight: 1.6 }}>
                      <li>
                        Use at least 8–12 characters (the longer, the better).
                      </li>
                      <li>Include a mix of uppercase and lowercase letters.</li>
                      <li>
                        Add numbers and special characters (like ! @ # $ % ^ &amp;
                        *).
                      </li>
                      <li>
                        Avoid using common words or easily guessed info (like your
                        name or birthday).
                      </li>
                      <li>Don't reuse passwords from other accounts.</li>
                      <li>
                        Consider using a passphrase (a few random words combined).
                      </li>
                      <li>
                        Change your password regularly to keep your account
                        secure.
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      
      </div>
    </div>
  );
}

export default Settings;